module.exports = __webpack_public_path__ + "img/beijing.829436fc.webp";